module.exports = __webpack_public_path__ + "img/file-export.a40bdc25.svg";